import React from 'react';
import { useVendor } from '@context/VendorContext';
import { useRouter } from 'next/router';
import { getDashboardRoutePath } from 'utils/routes-util';

import routes from '../../../config/routes';

import OrderingAlert from './OrderingAlert';
import type { AlertEnableOrderingProps } from './types';

export default function SetTaxSettings({
  compact,
  css,
  ctaText = 'Set Tax Settings',
  text = 'Help customers skip the line. Help yourself sell more food.',
}: AlertEnableOrderingProps) {
  const router = useRouter();
  const { vendorId } = useVendor();

  const setTaxSettings = () => {
    router.push(
      getDashboardRoutePath(`${routes.dashboard.settings.ordering}`, vendorId)
    );
  };

  return (
    <OrderingAlert
      buttonClick={setTaxSettings}
      compact={compact}
      css={css}
      ctaText={ctaText}
      icon="info"
      text={text}
      type="warning"
    />
  );
}
